<template>
  <div id="page-user-list">
    <div class="vx-row">
      <div class="vx-col lg:w-full w-full">
        <vx-card title="History by Product Categories (m3)" class="mb-8 mt-8">
          <div slot="no-body" class="mt-4">
            <vs-button style="float: right" class="mr-8 mb-4" @click=" removeFilter()">Disable Filter</vs-button>
            <vs-button v-if="displayExport != false" style="float: right" class="mr-8 mb-4"
              @click=" copyToClipboard('select_txt')">Copy To Clipboard</vs-button>
            <vs-table id="select_txt" stripe :data="categoryData">
              <template slot="thead">
                <vs-th>PRODUCT CATEGORIES</vs-th>
                <vs-th class="number">{{ currentMonthMoins6 }}</vs-th>
                <vs-th class="text-right">{{ currentMonthMoins5 }}</vs-th>
                <vs-th class="text-right">{{ currentMonthMoins4 }}</vs-th>
                <vs-th class="text-right">{{ currentMonthMoins3 }}</vs-th>
                <vs-th class="text-right">{{ currentMonthMoins2 }}</vs-th>
                <vs-th class="text-right">{{ currentMonthMoins1 }}</vs-th>
                <vs-th class="text-right">TODAY</vs-th>
                <vs-th style="text-align: right">UoM</vs-th>
                <vs-th style="text-align: right">Actions</vs-th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr :key="indextr" v-for="( tr, indextr ) in  data ">
                  <vs-td>
                    <span>
                      #{{ data[indextr].id }}.<b>
                        {{ data[indextr].category }}</b>
                    </span>
                  </vs-td>
                  <vs-td style="text-align: right">
                    <span v-if="parseFloat(data[indextr].gsp6) >= 0">
                      {{ data[indextr].gsp6 }}
                    </span>
                    <span v-else-if="parseFloat(data[indextr].gsp6) < 0" style="color: red">
                      {{ data[indextr].gsp6 }}
                    </span>
                    <span v-else> 0.00 </span>
                  </vs-td>

                  <vs-td style="text-align: right">
                    <span v-if="parseFloat(data[indextr].gsp5) >= 0">
                      {{ data[indextr].gsp5 }}
                    </span>
                    <span v-else-if="parseFloat(data[indextr].gsp5) < 0" style="color: red">
                      {{ data[indextr].gsp5 }}
                    </span>
                    <span v-else> 0.00 </span>
                  </vs-td>

                  <vs-td style="text-align: right">
                    <span v-if="parseFloat(data[indextr].gsp4) >= 0">
                      {{ data[indextr].gsp4 }}
                    </span>
                    <span v-else-if="parseFloat(data[indextr].gsp4) < 0" style="color: red">
                      {{ data[indextr].gsp4 }}
                    </span>
                    <span v-else> 0.00 </span>
                  </vs-td>

                  <vs-td style="text-align: right">
                    <span v-if="parseFloat(data[indextr].gsp3) >= 0">
                      {{ data[indextr].gsp3 }}
                    </span>
                    <span v-else-if="parseFloat(data[indextr].gsp3) < 0" style="color: red">
                      {{ data[indextr].gsp3 }}
                    </span>
                    <span v-else> 0.00 </span>
                  </vs-td>

                  <vs-td style="text-align: right">
                    <span v-if="parseFloat(data[indextr].gsp2) >= 0">
                      {{ data[indextr].gsp2 }}
                    </span>
                    <span v-else-if="parseFloat(data[indextr].gsp2) < 0" style="color: red">
                      {{ data[indextr].gsp2 }}
                    </span>
                    <span v-else> 0.00 </span>
                  </vs-td>

                  <vs-td style="text-align: right">
                    <span v-if="parseFloat(data[indextr].gsp1) >= 0">
                      {{ data[indextr].gsp1 }}
                    </span>
                    <span v-else-if="parseFloat(data[indextr].gsp1) < 0" style="color: red">
                      {{ data[indextr].gsp1 }}
                    </span>
                    <span v-else> 0.00 </span>
                  </vs-td>

                  <vs-td style="text-align: right">
                    <span v-if="parseFloat(data[indextr].gsp0) >= 0">
                      {{ data[indextr].gsp0 }}
                    </span>
                    <span v-else-if="parseFloat(data[indextr].gsp0) < 0" style="color: red">
                      {{ data[indextr].gsp0 }}
                    </span>
                    <span v-else> 0.00 </span>
                  </vs-td>

                  <vs-td>
                    <span v-if="data[indextr].category == 'Anti split plate'">
                      Pcs</span>
                    <span v-else> m3</span>
                  </vs-td>
                  <vs-td>
                    <feather-icon icon="FilterIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="
                      selectCategoryAndMoveUp(
                        data[indextr].id + ' ' + data[indextr].category
                      )
                      " />
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import vSelect from "vue-select";
import VueApexCharts from "vue-apexcharts";
const themeColors = ["#28C76F", "#EA5455", "#EA5455", "#FF9F43", "#1E1E1E"];
import moment from "moment";
import axios from "@/axios.js";

// Store Module
import moduleStockList from "@/store/stock/moduleOperationList.js";

// Cell Renderer
import CellRendererLink from "./cell-renderer/CellRendererLink.vue";
import CellRendererPopularity from "./cell-renderer/CellRendererPopularity.vue";
import CellRendererStatus from "./cell-renderer/CellRendererStatus.vue";
import CellRendererVerified from "./cell-renderer/CellRendererVerified.vue";
import CellRendererActions from "./cell-renderer/CellRendererActions.vue";

export default {
  components: {
    VueApexCharts,
    AgGridVue,
    vSelect,

    // Cell Renderer
    CellRendererLink,
    CellRendererStatus,
    CellRendererPopularity,
    CellRendererVerified,
    CellRendererActions,
  },
  data() {
    return {
      alreadyajusted: false,
      maxPopularity: 0,
      currentMonth: "Today",
      currentMonthMoins1: moment(moment(), "MM-YYYY")
        .subtract(1, "months")
        .format("MMMM YY")
        .toUpperCase(),
      currentMonthMoins2: moment(moment(), "MM-YYYY")
        .subtract(2, "months")
        .format("MMMM YY")
        .toUpperCase(),
      currentMonthMoins3: moment(moment(), "MM-YYYY")
        .subtract(3, "months")
        .format("MMMM YY")
        .toUpperCase(),
      currentMonthMoins4: moment(moment(), "MM-YYYY")
        .subtract(4, "months")
        .format("MMMM YY")
        .toUpperCase(),
      currentMonthMoins5: moment(moment(), "MM-YYYY")
        .subtract(5, "months")
        .format("MMMM YY")
        .toUpperCase(),
      currentMonthMoins6: moment(moment(), "MM-YYYY")
        .subtract(6, "months")
        .format("MMMM YY")
        .toUpperCase(),
      displayExport: false,
      evolutionStock: {},
      valuePiquet: [],
      valueBrut: [],
      isGraphFailed: true,
      searchQuery: "",

      // AgGrid
      gridApi: null,
      gridOptions: {},
      suppressSizeToFit: true,
      defaultColDef: {
        sortable: false,
        resizable: true,
        suppressMenu: true,
        suppressSizeToFit: false,
      },
      columnDefs: [
        {
          headerName: "#Internal ID",
          valueGetter: function (params) {
            return "#" + params.data.idproduct;
          },
          filter: true,
          //sort: 'DESC',
          width: 100,
          cellRendererFramework: "CellRendererLink",
          sortable: false,
        },
        {
          field: "category",
          headerName: "Product Category",
          valueGetter: function (params) {
            return "#" + params.data.idcategory + ". " + params.data.category;
          },
          filter: true,
          width: 250,
          sortable: false,
        },
        {
          headerName: "Product",
          valueGetter: function (params) {
            return params.data.product;
          },
          filter: true,
          width: 250,
          cellRendererFramework: "CellRendererLink",
          sortable: false,
        },
        {
          headerName: "Stock (UoM)",
          valueGetter: function (params) {
            return params.data.stock_uom;
          },
          //field: 'iscompany',
          filter: false,
          width: 160,
          type: "numericColumn",
          sortable: false,
        },
        {
          headerName: "Projected (UoM)",
          valueGetter: function (params) {
            if (params.data.stock_after_quotation)
              return params.data.stock_after_quotation;
            else return 0;
          },
          //field: 'iscompany',
          filter: false,
          width: 170,
          type: "numericColumn",
          sortable: false,
        },
        {
          headerName: "UoM",
          valueGetter: function (params) {
            return params.data.uom;
          },
          //field: 'iscompany',
          filter: false,
          width: 100,
          sortable: false,
        },
        {
          headerName: "Stock (m3)",
          valueGetter: function (params) {
            if (params.data.stock_volume) return params.data.stock_volume;
            else return " ";
          },
          //field: 'iscompany',
          filter: false,
          width: 160,
          type: "numericColumn",
          sortable: false,
        },
        {
          headerName: "Projected (m3)",
          valueGetter: function (params) {
            if (params.data.stock_after_quotation_volume)
              return params.data.stock_after_quotation_volume;
            else return "-";
          },
          //field: 'iscompany',
          filter: false,
          width: 160,
          type: "numericColumn",
          cellRendererFramework: "CellRendererStatus",
          sortable: false,
        },
        {
          headerName: "Popularity",
          field: "popularity",
          valueGetter: function (params) {
            if (params.data.popularity) return params.data.popularity;
            else return 0;
          },
          width: 130,
          sortable: false,
          cellRendererFramework: "CellRendererPopularity",
        },
      ],

      // Cell Renderer Components
      components: {
        CellRendererLink,
        CellRendererStatus,
        CellRendererPopularity,
        CellRendererVerified,
        CellRendererActions,
      },
    };
  },
  computed: {
    sizetofit() {
      if (this.gridApi) {
        if (this.gridApi.paginationGetTotalPages()) {
          if (this.alreadyajusted == false) {
            this.gridApi.sizeColumnsToFit();
            this.alreadyajusted = true;
          }
        }
      }
    },
    operationsData() {
      return this.$store.state.stockList.stocks;
    },
    categoryData() {
      return this.$store.state.stockList.stock_category;
    },
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize();
      else return 30;
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages();
      else return 0;
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1);
      },
    },
  },
  methods: {
    copyToClipboard(containerid) {
      var range = document.createRange();
      let containerNode = document.getElementById(containerid); //// this part
      range.selectNode(containerNode); //// this part
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
      document.execCommand("copy");
      window.getSelection().removeAllRanges();
      this.$vs.notify({
        color: "success",
        text:
          "Data copied to Clipboard!"
      });
    },
    removeFilter() {
      this.gridApi.setQuickFilter(null);
      window.scrollTo(0, 0);
    },
    selectCategoryAndMoveUp(val) {
      this.gridApi.setQuickFilter(val);
      window.scrollTo(0, 0);
    },
    getProductSortedByPopularity() {
      this.$vs.loading();
      this.$store
        .dispatch("stockList/fetchStocksByPopularity")
        .then((response) => {
          this.$vs.loading.close();
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getProductSortedByProjected() {
      this.$vs.loading();
      this.$store
        .dispatch("stockList/fetchStocks")
        .then((response) => {
          this.$vs.loading.close();
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getProductSortedByProjectedVolume() {
      this.$vs.loading();
      this.$store
        .dispatch("stockList/fetchStocksVolume")
        .then((response) => {
          this.$vs.loading.close();
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getProductSortedByName() {
      this.$vs.loading();
      this.$store
        .dispatch("stockList/fetchStocksv3")
        .then((response) => {
          this.$vs.loading.close();
        })
        .catch((err) => {
          console.error(err);
        });
    },
    setColumnFilter(column, val) {
      const filter = this.gridApi.getFilterInstance(column);
      let modelObj = null;

      if (val !== "all") {
        modelObj = { type: "equals", filter: val };
      }

      filter.setModel(modelObj);
      this.gridApi.onFilterChanged();
    },
    resetColFilters() {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null);
      this.gridApi.onFilterChanged();

      // Reset Filter Options
      this.roleFilter =
        this.statusFilter =
        this.isVerifiedFilter =
        this.departmentFilter =
        {
          label: "All",
          value: "all",
        };

      this.$refs.filterCard.removeRefreshAnimation();
    },
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val);
    },
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
  },
  created() {
    this.$vs.loading();
    if (localStorage.getItem("login-roles").toLowerCase().includes("admin")) {
      this.displayExport = true;
    }
    if (!moduleStockList.isRegistered) {
      this.$store.registerModule("stockList", moduleStockList);
      moduleStockList.isRegistered = true;
    }
    this.$store
      .dispatch("stockList/fetchStockByCategory")
      .then((response) => {
        this.$vs.loading.close();
      })
  },
};
</script>
<style lang="scss" scpoped>
/*
.ag-grid-cell-chip {
  &.vs-chip-success {
    background: rgba(var(--vs-success), 1);
    color: white !important;
  }
  &.vs-chip-warning {
    background: rgba(var(--vs-warning), 1);
    color: white !important;
  }
  &.vs-chip-danger {
    background: rgba(var(--vs-danger), 1);
    color: white !important;
  }
}*/
</style>
